import React from 'react'

const Info = () => {
  return (
    <section className="info">
        <div className="info__container container">
            <h2 className='info__title title'>О системе</h2>
            <h3 className='info__subtitle'>Анкетирование ДГУ</h3>
            <p className="info__text">
                Анкетирование проводится для улучшения качества преподавания ДГУ. 
                Данное исследование и его результаты будут использованы только в обобщенном виде, а данные о ФИО студентов будут засекречены.
            </p>
        </div>
    </section>
  )
}

export default Info